module.exports = __webpack_public_path__ + "static/media/video.b3a8207e.svg";